"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobx_1 = require("mobx");

var react_fast_compare_1 = __importDefault(require("react-fast-compare"));

var lodash_1 = require("lodash");

var core_1 = require("@bodiless/core"); // Create the onChange prop.
// @TODO Should be memoized with useCallback.


var useOnChange = function useOnChange(_a) {
  var onChange = _a.onChange,
      initialValue = _a.initialValue;
  var node = core_1.useNode().node;
  var nodeData = node.data;

  if (mobx_1.isObservable(nodeData)) {
    nodeData = mobx_1.toJS(nodeData);
  }

  return function (value) {
    // If Document has changed
    var isDocumentChanged = !react_fast_compare_1.default(nodeData, value); // If the value is initial value

    var isNewValueInitial = react_fast_compare_1.default(initialValue, value); // If New Value is Empty

    var isNewValueEmpty = isNewValueInitial && !lodash_1.isEmpty(nodeData) && isDocumentChanged; // If New Value Has Changes

    var isNewValueChanged = !isNewValueInitial && (!nodeData || isDocumentChanged);

    if (isNewValueEmpty || isNewValueChanged) {
      node.setData(value);
    }

    if (onChange) {
      onChange(value);
    }
  };
}; // Create the value prop (gets current editor value from state).


var useValue = function useValue() {
  var node = core_1.useNode().node;
  return mobx_1.toJS(node.data);
};

var useNodeStateHandlers = function useNodeStateHandlers(_a) {
  var initialValue = _a.initialValue,
      onChange = _a.onChange;
  var key = core_1.useUUID();
  return {
    value: useValue({
      initialValue: initialValue,
      key: key
    }),
    onChange: useOnChange({
      onChange: onChange,
      key: key,
      initialValue: initialValue
    })
  };
};

exports.default = useNodeStateHandlers;